"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var utils_2 = require("@qwilr/kaleidoscope/utils");
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var classnames_1 = __importDefault(require("classnames"));
var c = (0, BemBuilder_1.default)("section-select-button");
var QuoteSelectButton = (function (_super) {
    __extends(QuoteSelectButton, _super);
    function QuoteSelectButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuoteSelectButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, onClick = _a.onClick, selected = _a.selected;
        return (react_1.default.createElement("button", { className: (0, classnames_1.default)(c(), "user-font"), onClick: onClick, onMouseUp: utils_1.handleMouseUpByBlurring, "aria-pressed": selected, disabled: !this.quoteViewStore.isInteractive },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(c("label"), c("label", "hidden")) }, selected ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(icons_1.Tick, null),
                this.quoteViewStore.getLabel(Types_1.QuoteLabel.Selected))) : (react_1.default.createElement(react_1.default.Fragment, null, this.quoteViewStore.getLabel(Types_1.QuoteLabel.Select)))),
            react_1.default.createElement(react_transition_group_1.TransitionGroup, { component: null },
                !selected && (react_1.default.createElement(react_transition_group_1.Transition, { in: true, timeout: kaleidoscope_1.AnimationDuration.Medium, onEnter: utils_2.forceReflow }, function (status) { return (react_1.default.createElement("div", { className: c("label-wrapper") },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(c("label"), c("label", "unselected"), c("label", status)) }, _this.quoteViewStore.getLabel(Types_1.QuoteLabel.Select)))); })),
                selected && (react_1.default.createElement(react_transition_group_1.Transition, { in: true, timeout: kaleidoscope_1.AnimationDuration.Medium, onEnter: utils_2.forceReflow }, function (status) { return (react_1.default.createElement("div", { className: c("label-wrapper") },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(c("label"), c("label", "selected"), c("label", status)) },
                        react_1.default.createElement(icons_1.Tick, null),
                        _this.quoteViewStore.getLabel(Types_1.QuoteLabel.Selected)))); })))));
    };
    var _a;
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_a = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _a : Object)
    ], QuoteSelectButton.prototype, "quoteViewStore", void 0);
    QuoteSelectButton = __decorate([
        mobx_react_1.observer
    ], QuoteSelectButton);
    return QuoteSelectButton;
}(react_1.default.Component));
exports.default = QuoteSelectButton;
